import { useContextSelector } from "use-context-selector"
import { WalletLayoutContext } from "./WalletLayoutProvider.react"

export const useWalletLayoutHeader = () =>
  useContextSelector(WalletLayoutContext, ({ Header }) => Header)
